<template>
	<v-container>
		<v-card color="transparent" class="cardStyle">
			<v-tooltip right>
				<template v-slot:activator="{ on, attrs }">
					<v-btn id="btnComponentIcon" elevation="0" class="iconButton" :style="cssProps" v-on="on" :to="{ name: route }">
						<p center>
						<v-img style="opacity:0.5;" width="150" height="150" contain :src="iconLink"/>
						</p>
					</v-btn>
				</template>
				<span>{{ this.appDescription }}</span>
			</v-tooltip>
			<hr style="margin-bottom:10px;opacity:0.5;"/>
			<span display="block" class="spanStyle">{{ this.appName }}</span>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'Card',
	props: ['iconLink', 'appName', 'appDescription', 'color', 'route'],
	data() {
		return {}
	},
	computed: {
		cssProps() {
			return {
				'background-color': this.color,
			}
		},
	}
}
</script>

<style>
.iconButton {
	height: 200px !important;
	width: 100%;
	border: 0 !important;
}
.cardStyle {
	min-width: 100px;
	max-width: 250px;
	height: 250px;
}
</style>
